import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="m420-481 170 170q12 12 11 28t-12 28q-12 12-29 12t-28-12L335-453q-6-6-9-13-4-7-4-15t4-15q3-7 9-13l198-199q12-12 29-12t28 12q12 12 12 29t-12 28L420-481Z"/>',
  f: '<path d="m420-481 170 170q12 12 11 28t-12 28q-12 12-29 12t-28-12L335-453q-6-6-9-13-4-7-4-15t4-15q3-7 9-13l198-199q12-12 29-12t28 12q12 12 12 29t-12 28L420-481Z"/>',
};

export default data;
